module.exports = "<h3  translate=\"403_access_denied\" translate-default=\"403 - Access denied\">403 - Access denied</h3>\n<h4 translate=\"access_denied_text\" translate-default=\"Sorry, you’re not allowed to access this page.\">Sorry, you’re not allowed to access this page.</h4>";


//////////////////
// WEBPACK FOOTER
// ./src/app.common/modules/templates/forbidden.html
// module id = 15
// module chunks = 0 1 2 3 4